import api from "@/api";

const state = {
  status: "",
  list: [],
  FixedAssetType: {
    Terminal: 0,
    GPS: 1,
    SIM: 2
  },
  availableDevices: [],
  availableSIMS: []
};

const getters = {
  isLoading: (state) => state.status === "loading"
};

const actions = {
  getAvailableDevices: (
    { commit, rootState },
    { serial, product_code, fixed_asset_type }
  ) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/inventory/availableDevices", {
          timeout: 3 * 60 * 1000, // Espera hasta 3 minutos
          params: {
            CompanyCode: rootState.user.user.CompanySelected,
            Serial: serial,
            LocationCode: product_code,
            AssetType: fixed_asset_type
          }
        })
        .then(({ data }) => {
          commit("success");
          commit("availableDevices", data);
          resolve(data);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  getAvailableSIMS: ({ commit, rootState }, { phone, deviseSerial }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/inventory/availableSims", {
          timeout: 3 * 60 * 1000, // Espera hasta 3 minutos
          params: {
            PhoneNumber: phone,
            DeviceSerial: deviseSerial,
            CompanyID: rootState.user.user.CompanySelected
          }
        })
        .then(({ data }) => {
          const { Items } = data;
          commit("success");
          commit("availableSIMS", Items);
          resolve(Items);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  }
};

const mutations = {
  loading: (state) => {
    state.status = "loading";
  },
  success: (state) => {
    state.status = "success";
  },
  error: (state) => {
    state.status = "error";
  },
  list: (state, data) => {
    state.list = data;
  },
  availableDevices: (state, availableDevices) => {
    state.availableDevices = availableDevices;
  },
  availableSIMS: (state, availableSIMS) => {
    state.availableSIMS = availableSIMS;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
